import LockIcon from '@mui/icons-material/Lock';
import Accordion from '@zenbusiness/zui/Accordion';
import Avatar from '@zenbusiness/zui/Avatar';
import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import Divider from '@zenbusiness/zui/Divider';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';
import SvgIcon from '@zenbusiness/zui/SvgIcon';
import Text from '@zenbusiness/zui/Text';

export const InvoiceCardRoot = superstyled({
  name: 'InvoiceCard',
  slot: 'root',
  tag: Card,
  propsNeeded: ['isLocked'],
  propsAdded: {
    elevation: 3,
    variant: 'elevation',
  },
  styles: ({ theme, isLocked }) => ({
    backgroundColor: isLocked ? theme.palette.background.grey.dark : theme.palette.background.paper,
    padding: theme.spacing(3),
  }),
});

export const InvoiceCardAccordion = superstyled({
  name: 'InvoiceCard',
  slot: 'accordion',
  tag: Accordion,
  propsNeeded: ['isLocked'],
  styles: ({ theme, isLocked }) => {
    if (!isLocked) {
      return {};
    }

    return {
      background: theme.palette.background.grey.dark,
    };
  },
});

export const InvoiceCardHeader = superstyled({
  name: 'InvoiceCard',
  slot: 'header',
  tag: Box,
  styles: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
});

export const InvoiceCardAvatar = superstyled({
  name: 'InvoiceCard',
  slot: 'avatar',
  tag: Avatar,
  styles: {
    width: 40,
    height: 40,
  },
});

export const InvoiceCardAmountColumn = superstyled({
  name: 'InvoiceCard',
  slot: 'amountColumn',
  tag: Stack,
  propsAdded: {
    alignItems: 'flex-end',
    spacing: 0.5,
  },
});

export const InvoiceCardTitleRow = superstyled({
  name: 'InvoiceCard',
  slot: 'titleRow',
  tag: Stack,
  propsAdded: {
    alignItems: 'center',
    direction: 'row',
    spacing: 2,
  },
});

export const InvoiceCardDetailsSurface = superstyled({
  name: 'InvoiceCard',
  slot: 'detailsSurface',
  tag: Card,
  propsNeeded: ['isLocked'],
  propsAdded: {
    color: 'paper',
    variant: 'outlined',
  },
  styles: ({ theme, isLocked }) => ({
    backgroundColor: isLocked ? theme.palette.background.grey.dark : theme.palette.background.paper,
    marginTop: theme.spacing(1),
  }),
});

export const InvoiceCardDetailsContent = superstyled({
  name: 'InvoiceCard',
  slot: 'detailsContent',
  tag: CardContent,
});

export const InvoiceCardDivider = superstyled({
  name: 'InvoiceCard',
  slot: 'divider',
  tag: Divider,
  styles: ({ theme }) => ({
    marginTop: theme.spacing(2),
  }),
});

export const InvoiceCardLockIcon = superstyled({
  name: 'InvoiceCard',
  slot: 'lockIcon',
  tag: SvgIcon,
  propsAdded: {
    color: 'text.secondary',
    component: LockIcon,
    size: '3xl',
  },
});

export const InvoiceCardActions = superstyled({
  name: 'InvoiceCard',
  slot: 'actions',
  tag: Stack,
  propsAdded: {
    spacing: 1.5,
  },
  styles: ({ theme }) => ({
    marginTop: theme.spacing(2),
  }),
});

export const InvoiceCardPaymentLogo = superstyled({
  name: 'InvoiceCard',
  slot: 'paymentLogo',
  tag: SharedAsset,
  propsAdded: {
    height: 20,
  },
});

export const InvoiceCardPrimaryButton = superstyled({
  name: 'InvoiceCard',
  slot: 'primaryButton',
  tag: Button,
  propsAdded: {
    fullWidth: true,
    variant: 'contained',
  },
});

export const InvoiceCardSecondaryButton = superstyled({
  name: 'InvoiceCard',
  slot: 'secondaryButton',
  tag: Button,
  propsAdded: {
    fullWidth: true,
    variant: 'outlined',
  },
});

export const InvoiceCardTitle = superstyled({
  name: 'InvoiceCard',
  slot: 'title',
  tag: Text,
  propsAdded: {
    size: 'md',
    weight: 'medium',
  },
});

export const InvoiceCardDueDate = superstyled({
  name: 'InvoiceCard',
  slot: 'dueDate',
  tag: Text,
  propsAdded: {
    color: 'secondary',
    size: 'sm',
  },
});

export const InvoiceCardAmount = superstyled({
  name: 'InvoiceCard',
  slot: 'amount',
  tag: Text,
  propsAdded: {
    size: 'lg',
    weight: 'medium',
  },
  styles: {
    textAlign: 'right',
  },
});

export const InvoiceCardCreditNote = superstyled({
  name: 'InvoiceCard',
  slot: 'creditNote',
  tag: Text,
  propsAdded: {
    color: 'secondary',
    size: 'xs',
  },
  styles: {
    textAlign: 'right',
  },
});

export const InvoiceCardLockedMessage = superstyled({
  name: 'InvoiceCard',
  slot: 'lockedMessage',
  tag: Text,
  propsAdded: {
    color: 'secondary',
    size: 'sm',
  },
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  }),
});
